import { uploadProjectAttachmentApi } from '../api/chat.api';

export const REFERENCE_IMAGE_MAX_COUNT = 5;
export const REFERENCE_IMAGE_MAX_SIZE_BYTES = 5 * 1024 * 1024;
export const REFERENCE_IMAGE_MAX_SIZE_MB = REFERENCE_IMAGE_MAX_SIZE_BYTES / (1024 * 1024);

export const listImageFiles = (fileList) =>
  Array.from(fileList || []).filter((file) => file instanceof File);

export const getReferenceImageKey = (file) => `${file.name}-${file.size}-${file.lastModified}`;

export const validateReferenceImage = (file, maxSizeBytes = REFERENCE_IMAGE_MAX_SIZE_BYTES) => {
  if (!(file instanceof File)) {
    return { ok: false, errorKey: 'aiReferenceImagesInvalidType' };
  }

  if (!file.type || !file.type.startsWith('image/')) {
    return { ok: false, errorKey: 'aiReferenceImagesInvalidType' };
  }

  if (file.size > maxSizeBytes) {
    return { ok: false, errorKey: 'aiReferenceImagesTooLarge' };
  }

  return { ok: true, errorKey: null };
};

export const uploadReferenceImages = async ({ projectId, files = [], onProgress }) => {
  const urls = [];
  const errors = [];

  for (let index = 0; index < files.length; index += 1) {
    const file = files[index];
    onProgress?.(index + 1, files.length);

    try {
      const attachment = await uploadProjectAttachmentApi({ projectId, file });

      if (!attachment.url) {
        errors.push({ fileName: file.name, messageKey: 'attachmentUploadMissingUrl' });
        continue;
      }

      urls.push(attachment.url);
    } catch (error) {
      errors.push({
        fileName: file.name,
        message: error?.message || 'attachmentUploadFailed',
        messageKey: 'attachmentUploadFailed'
      });
    }
  }

  return { urls, errors };
};
